export default "__VITE_ASSET__d1e13644__"